<template>
  <div class="">
    <div class="notification is-warning is-padding-small is-marginless is-flex is-vcentered is-minH50p">
      <div class="is-self-centered has-text-centered w100 is-uppercase is-size-7">
        <span class="is-margin-right-xsmall">
          <span class="icon has-text-danger"><i class="fas fa-exclamation-triangle"></i></span>
        </span>
        <b class="has-text-weight-medium">
          une procédure DE RECOMMANDÉ ELECTRONIQUE LRE (lettre recommandé maiL) ne peut pas être annulée.
        </b>
      </div>
    </div>
    <!-- <div class="notification is-success is-padding-xsmall is-marginless is-flex is-vcentered">
      <div class="is-self-centered has-text-centered w100 is-uppercase is-size-7">
        <b class="has-text-weight-medium">
          Clés de sécurité détectée, vous pouvez envoyer directement sans rentrer de code
        </b>
      </div>
    </div> -->
    <div class="columns is-gapless is-padding">
      <div class="column is-narrow is-size-5 is-size-6-widescreen is-size-4-fullhd">
        <i class="fal fa-5x fa-mail-bulk"></i>
      </div>
      <div class="column is-margin-left-large is-padding-top-xxsmall">
        <div class="title is-3 has-text-weight-medium is-margin-bottom-small">
          Vous vous apprétez à envoyer un courrier recommandé éléctronique (LRE)
        </div>
        <div class="is-size-6 is-italic">
          La Lettre Recommandée Electronique, ou LRE, est le remplaçant numérique du courrier recommandé postal reconnu par la loi française.
          <b>Si le destinataire n’est pas un professionnel, il est nécessaire de recueillir son accord pour lui faire parvenir une LRE.
            Dans tous les cas il est necessaire de disposer d’un mail validé et enregistré dans la fiche de l’acquéreur ou co-acquéreur.</b>
        </div>
        <div class="columns is-variable is-2 is-centered is-padding-top-small is-padding-bottom-small">
          <div class="column is-5">
            <r-label
              :for="code"
              :value="code"
              label="Code d’authentification"
              class="label"></r-label>
            <v-input
              :model="code"
              :name="'code'"
              :errors-bag="errors"
              data-vv-value-path="val"
              v-validate="'required|min:6|max:6'"
              @input="val => code = val"
              data-vv-as="code d’authentification"
              label=""
              :classes="''"
              :classes-input="'is-fullwidth is-medium has-text-centered has-background-white-bis'">
            </v-input>
          </div>
          <div class="column is-7">
            <r-label
              :for="''"
              :label="'&nbsp;'"
              class="label is-uppercase"
              :is-required="false"></r-label>
            <button
              @click="submitLre"
              class="button is-medium is-success is-fullwidth is-radiusless">
              <i
                v-if="loading"
                class="fas fa-spinner fa-spin"></i>
              <span
                v-else
                class="is-size-6 has-text-weight-medium">ENVOYER RECOMMANDÉ ELECTRONIQUE</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Error } from '@/mixins'
export default {
  name: 'BeforeDematSru',
  mixins: [Error],
  props: {
    requestElem: {
      type: Object
    },
    buyerPk: {
      type: String
    },
    from: {
      type: String
    }
  },
  data () {
    return {
      loading: false,
      code: null
    }
  },
  methods: {
    /**
      * submit lre
      * post adf lre or reservation lre
      */
    async submitLre () {
      this.loading = true
      const formIsValid = await this.$validator.validateAll()
      if (!this.code || this.code === '' || !formIsValid) {
        this.$toasted.global.danger('Veuillez rentrer un code d\'authenfication valide')
        return
      }
      let params = {
        buyer: this.buyerPk,
        otp: this.code,
        eidas: 1
      }
      try {
        let lre
        if (this.from === 'adf') {
          params.construction_step_uuid = this.requestElem.step_uuid
          let { data } = await this.$api.post(`/reservations/${this.requestElem.adv_pk}/lre/adf-notice`, params)
          lre = data
        } else {
          let { data } = await this.$api.post(`/reservations/${this.requestElem.adv_pk}/lre/reservation-contract`, params)
          lre = data
        }
        this.$emit('sendInfo', lre)
        this.$emit('goToDemat', lre)
      } catch (err) {
        this.handleError(err)
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    /**
      * emit change modal
      * @param {string} val
      */
    changeModal (val) {
      this.$emit('changeModal', val)
    }
  }
}
</script>
